import React, { ReactNode } from "react";
import { Flex, Box, Text, IBoxProps, TouchableOpacity } from "@atoms";
import { theme } from "@styles";
import { renderIf } from "@services";
// import styled from "@emotion/styled";

// == Types ================================================================

interface IProps extends IBoxProps {
  text: string;
  subText?: string;
  leftComponent: ReactNode;
  onTouch?: () => void | null;
}

// == Constants ============================================================

const DEFAULT_PROPS = {
  onTouch: null,
  subText: null,
};

// == Component ============================================================

const ImageListItem = ({ text, subText, leftComponent, onTouch, ...rest }: IProps) => {
  const component = (
    <Flex alignItems="center" {...rest}>
      <Box height={theme.sizes.profileImageSize} mr={2} width={theme.sizes.profileImageSize}>
        {leftComponent}
      </Box>
      <Box minWidth="0px">
        <Text ellipsis color="default" display="block" fontSize={2} lineHeight="solid">
          {text}
        </Text>
        {renderIf(!!subText)(
          <Text ellipsis color="subText" fontSize={1}>
            {subText}
          </Text>
        )}
      </Box>
    </Flex>
  );

  if (!onTouch) return component;

  return <TouchableOpacity onTouch={onTouch}>{component}</TouchableOpacity>;
};

ImageListItem.defaultProps = DEFAULT_PROPS;
export default ImageListItem;

// == Styles ===============================================================
